module.exports = __webpack_public_path__ + "img/img_year_bg.e79b150a.png";